var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"episode-camera-groups"},[_vm._v(_vm._s(_vm.$tf('camera_group'))+": "+_vm._s(_vm.cameraGroupNames))])}
var staticRenderFns = []

export { render, staticRenderFns }